import { Navigate, Outlet } from "react-router-dom";
import { useIsAdmin } from "@/features/auth";

export default function AdminRoute() {
  const isAdmin = useIsAdmin();

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
